import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import "@/App.css";
import { I18nProvider } from "@/i18n";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import ServiceMaintenance from "@/pages/ServiceMaintenance";
import ServiceInformatique from "@/pages/ServiceInformatique";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

function ScrollTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const id = hash.replace("#", "");
      const el = document.getElementById(id);
      if (el) {
        setTimeout(() => el.scrollIntoView({ behavior: "smooth", block: "start" }), 60);
        return;
      }
    }
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname, hash]);
  return null;
}

function ProtectedAdmin({ children }) {
  const token = typeof window !== "undefined" ? localStorage.getItem("gsm_token") : null;
  if (!token) return <Navigate to="/admin" replace />;
  return children;
}

function Layout({ children, hideChrome }) {
  return (
    <div className="App grain relative">
      {!hideChrome && <Header />}
      <main className="relative z-10">{children}</main>
      {!hideChrome && <Footer />}
    </div>
  );
}

function AppShell() {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith("/admin");
  return (
    <>
      <ScrollTop />
      <Layout hideChrome={isAdminRoute}>
        {isAdminRoute && (
          <div className="border-b border-stone-200 bg-white">
            <div className="max-w-7xl mx-auto px-6 lg:px-10 h-16 flex items-center justify-between">
              <a href="/" className="flex items-center gap-2" data-testid="admin-home-link">
                <div className="w-8 h-8 rounded-md bg-[#B95736] flex items-center justify-center text-white font-serif text-lg leading-none">G</div>
                <span className="font-serif text-lg text-stone-900">GSM Service Maintenance</span>
              </a>
              <span className="text-[10px] tracking-[0.22em] uppercase text-stone-500 font-mono">Admin</span>
            </div>
          </div>
        )}
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/services/maintenance" element={<ServiceMaintenance />} />
          <Route path="/services/informatique" element={<ServiceInformatique />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<ProtectedAdmin><AdminDashboard /></ProtectedAdmin>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Layout>
    </>
  );
}

export default function App() {
  return (
    <I18nProvider>
      <BrowserRouter>
        <AppShell />
      </BrowserRouter>
    </I18nProvider>
  );
}
